import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { Order } from '~/components/Account/Logged/Orders/types'
import Image from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import { ACCOUNT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [{ breakpoint: 'lg', ratio: 4 / 24 }, { ratio: 4 / 16 }]

export type OrderProductsProps = {
  className?: string
  products: Order['products']
}

function OrderProducts({ className, products }: OrderProductsProps) {
  const t = useTranslate()

  const designerStyle = useStyle({
    textPreset: GlobalTextPreset.Title15SangBleu,
    color: GlobalThemeColors.Black,
  })

  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskMedium,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  const labelStyle = useStyle({
    textPreset: GlobalTextPreset.Label10Grotesk,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Gray,
  })

  return (
    <div className={cx(className, css.OrderProducts)}>
      {products?.map((product, index) => (
        <div
          key={`orderDetailsProductItem${index}`}
          className={cx(css.product)}>
          <div className={css.imageWrapper}>
            {product?.image && (
              <Image
                className={css.image}
                ratio={css.ratio}
                sizesFromBreakpoints={IMAGE_SIZES}
                layout="fill"
                objectFit="cover"
                asPlaceholder
                src={product.image}
              />
            )}
            {product?.sku && <span className={labelStyle}>{product.sku}</span>}
          </div>
          <div className={cx(textStyle, css.details)}>
            {product?.label && (
              <p className={cx(designerStyle, css.designer)}>{product.label}</p>
            )}
            {product?.name && (
              <div className={cx(css.name)}>{product.name}</div>
            )}
            {product?.quantity && product?.price && (
              <p className={css.priceAndQuantity}>
                {product.quantity} x {product.price}
              </p>
            )}
            {!product?.isUniqueSize && (
              <div className={css.sizeWrapper}>
                <p>{t(ACCOUNT.ORDER_SIZE)}</p>
                <div className={css.size}>
                  <span>{product?.size}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

OrderProducts.defaultProps = {}

export default OrderProducts
